import { Row, Col, Table, Spinner } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function ServidoresRemuneracao() {
    const [remuneracoes, setRemuneracoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [competencia, setCompetencia] = useState(null);

    useEffect(() => {
        fetch("https://dadosabertos.alepe.pe.gov.br/api/v1/remuneracao/")
            .then(result => result.json())
            .then(data => {
                setRemuneracoes(data);
                const comCompetencia = data.filter(d => d.mesCompetencia && d.anoCompetencia);
                if (comCompetencia.length > 0) {
                    const oldest = comCompetencia.reduce((min, d) =>
                        d.anoCompetencia < min.anoCompetencia ||
                        (d.anoCompetencia === min.anoCompetencia && d.mesCompetencia < min.mesCompetencia)
                            ? d : min
                    );
                    const date = new Date(oldest.anoCompetencia, oldest.mesCompetencia - 1);
                    setCompetencia(date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }));
                }
                setLoading(false);
            });
    }, []);

    const filterByType = (tipo) => remuneracoes.filter(item => item.tipoCargo === tipo);

    return (
        <div>
            <Row>
                <Col xs="12">
                    <p>
                        <small>
                            Você está em <a href="/pessoal">Gestão de Pessoas</a> / Tabelas de Remuneração
                        </small>
                    </p>
                    {competencia && <p><small>Dados atualizados em {competencia}</small></p>}
                </Col>
                {!loading ? (
                    <Col xs="12">
                        <RemunerationTable 
                            title="Cargos Comissionados Administrativos" 
                            data={filterByType("Cargo Comissionado Administrativo")} 
                            footer="A remuneração dos cargos comissionados administrativos inclui Vencimento e Gratificação de Representação."
                        />

                        <RemunerationTable 
                            title="Cargos Comissionados de Gabinete" 
                            data={filterByType("Cargo Comissionado de Gabinete")} 
                            footer="A remuneração dos cargos comissionados de gabinete inclui Gratificação de Representação variável de 0 a 120%."
                        />

                        <RemunerationTable 
                            title="Cargos Efetivos" 
                            data={filterByType("Cargo Efetivo")} 
                            footer="A remuneração dos procuradores inclui Vencimento, Gratificação de Representação e Gratificação de Produtividade."
                        />

                        <RemunerationTable 
                            title="Cargos Extintos Após Vacância" 
                            data={filterByType("Cargo Extinto Após Vacância")}
                        />
                        <div className="mt-5">
                            <h4>LEGISLAÇÃO PESSOAL DA ALEPE</h4>
                            <ul>
                                <li>LEI Nº 10.568 DE 4 DE ABRIL DE 1991</li>
                                <li>LEI Nº 11.641, DE 4 DE MAIO DE 1999</li>
                                <li>LEI Nº 12.312, DE 20 DE DEZEMBRO DE 2002</li>
                                <li>LEI Nº 12.777, DE 23 DE MARÇO DE 2005</li>
                                <li>LEI Nº 13.245, DE 13 DE JUNHO DE 2007</li>
                                <li>LEI Nº 13.299, DE 21 DE SETEMBRO DE 2007</li>
                                <li>LEI Nº 14.659, DE 9 DE MAIO DE 2012</li>
                                <li>LEI Nº 15.160, DE 27 DE NOVEMBRO DE 2013</li>
                                <li>LEI Nº 15.161, DE 27 DE NOVEMBRO DE 2013</li>
                                <li>LEI Nº 15.486, DE 20 DE ABRIL DE 2015</li>
                                <li>LEI Nº 15.571, DE 10 DE SETEMBRO DE 2015</li>
                                <li>LEI Nº 15.940, DE 12 DE DEZEMBRO DE 2016</li>
                                <li>LEI Nº 15.985, DE 23 DE FEVEREIRO DE 2017</li>
                                <li>LEI Nº 16.328, DE 5 DE ABRIL DE 2018</li>
                                <li>LEI Nº 16.578, DE 22 DE MAIO DE 2019</li>
                                <li>LEI Nº 16.579, DE 22 DE MAIO DE 2019</li>
                                <li>LEI Nº 17.541, DE 15 DE DEZEMBRO DE 2021</li>
                                <li>LEI Nº 17.720, DE 1º DE ABRIL DE 2022</li>
                                <li>LEI Nº 18.150, DE 25 DE ABRIL DE 2023</li>
                                <li>LEI Nº 18.355, DE 23 DE OUTUBRO DE 2023</li>
                                <li>LEI Nº 18.469, DE 27 DE DEZEMBRO DE 2023</li>
                                <li>LEI Nº 18.549, DE 6 DE MAIO DE 2024</li>
                                <li>LEI Nº 18.758, DE 10 DE DEZEMBRO DE 2024</li>
                                <li>LEI Nº 18.864, DE 11 DE ABRIL DE 2025</li>
                            </ul>
                        </div>

                    </Col>
                ) : (
                    <Col xs="12" className="text-center">
                        <Spinner />
                    </Col>
                )}
            </Row>
        </div>
    );
}

function RemunerationTable({ title, data, footer }) {
    return (
        <div className="table-responsive mb-4">
            <h3>{title}</h3>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Cargo</th>
                        <th>Remuneração</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((cargo, index) => (
                            <tr key={index}>
                                <td>{cargo.cargo.trim()}</td>
                                <td>{cargo.remuneracao ? `R$ ${Number(cargo.remuneracao).toFixed(2).replace('.', ',')}` : "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="2" className="text-center">Nenhum dado disponível</td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="2">{footer}</td>
                    </tr>
                </tfoot>
            </Table>
        </div>
    );
}
